import React, { useEffect, useRef, useState } from "react";
import UnlimitInput from "./ui-kit/unlimit-input";
import { useForm } from "react-hook-form";
import UnlimitSubmitButton from "./ui-kit/unlimit-submit-button";
import httpService from "../services/http/settings/system-language.service";
import notificationService from "../services/toaster.service";
import { store } from "../core/redux/store";
import { hydrateErrors } from "../utils/error.utils";
import UnlimitSelect from "./ui-kit/unlimit-select";
import UnlimitToggle from "./ui-kit/unlimit-toggle";
import systemLanguageService from "../services/http/settings/system-language.service";
import { useTranslation } from "react-i18next";

const SystemLanguageDetail = ({ onHide, systemLanguage }) => {
  const {
    register,
    handleSubmit,
    formState,
    setValue,
    setError,
    reset,
    control,
    getValues
  } = useForm();
  const { errors } = formState;
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const modalRef = useRef();
  const { auth, locations } = store.getState();
  const { t } = useTranslation();
  const onSubmitForm = async (data) => {
    const user = auth.user;
    try {
      setIsLoading(true);
      const requestData = {
        name: data.name,
        is_active: data.is_active ? 1 : 0,
        created_by: user.id,
        short_code: data.short_code,
        country_iso2:data.country_iso2.iso2
      };
      if (systemLanguage) {
        requestData.id = systemLanguage.id;
        await updateSystemLanguage(requestData);
      } else {
        await createSystemLanguage(requestData);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const createSystemLanguage = async (formData) => {
    try {
      const response = await httpService.createSystemLanguage(formData, true);
      if (response && response.status === 200) {
        notificationService.successMessage(
          t("systemLanguage.systemLanguageCreateSuccess")
        );
        onHide();
        reset();
        modalHide();
      }
    } catch (error) {
      if (error.validation_error.errors) {
        hydrateErrors(error.validation_error.errors, setError);
      }
    }
  };
  const updateSystemLanguage = async (formData) => {
    try {
      const response = await httpService.updateSystemLanguage(formData, true);
      if (response && response.status === 200) {
        notificationService.successMessage(
          t("systemLanguage.systemLanguageUpdateSuccess")
        );
        onHide();
        reset();
        modalHide();
      }
    } catch (error) {
      if (error.validation_error.errors) {
        hydrateErrors(error.validation_error.errors, setError);
      }
    }
  };
  const modalHide = () => {
    const cancelButton = document.querySelector(".btn-cancel");
    if (cancelButton) {
      cancelButton.click();
    }
  };
  useEffect(() => {
    if (systemLanguage) {
      setValue("name", systemLanguage.name);
      setValue("is_active", systemLanguage.is_active == 1 ? true : false);
      setValue("short_code", systemLanguage.short_code);
      const selectedCountry = locations?.countries?.find((country)=> country?.iso2?.toLowerCase() == systemLanguage?.country_iso2?.toLowerCase())
      if(selectedCountry) setValue("country_iso2", {...selectedCountry,value:selectedCountry?.id,label:selectedCountry?.iso2});
    }
  }, [systemLanguage]);
  useEffect(() => {
    setCountries(locations.countries);
  }, []);
  useEffect(() => {
    const modalElement = modalRef.current;
    const handleShow = () => {
      console.log("Handle show");
    };
    const handleHide = () => {
      reset();
      onHide();
    };
    modalElement.addEventListener("show.bs.modal", handleShow);
    modalElement.addEventListener("hide.bs.modal", handleHide);

    return () => {
      modalElement.removeEventListener("show.bs.modal", handleShow);
      modalElement.removeEventListener("hide.bs.modal", handleHide);
    };
  }, [onHide]);
  return (
    <div>
      <div className="modal fade" id="add-systemLanguage" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div></div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(onSubmitForm)}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <UnlimitInput
                            label={t("language.language")}
                            id="name"
                            type="text"
                            placeholder={t("language.language")}
                            register={register}
                            rules={{
                              required: t("inputField.validation.required"),
                              pattern: {
                                value: /^[a-zA-Z\s]*$/,
                                message: t("inputField.validation.pattern"),
                              },
                            }}
                            error={errors.name}
                            errorMessage={errors.name?.message}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <UnlimitInput
                            label={t("tableColumnName.shortCode")}
                            id="short_code"
                            type="text"
                            placeholder={t("tableColumnName.shortCode")}
                            register={register}
                            rules={{
                              required: t("inputField.validation.required"),
                            }}
                            error={errors.short_code}
                            errorMessage={errors.short_code?.message}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 mb-3">
                      <UnlimitSelect
                        label={t("country.countryiSO2")}
                        id="country_iso2"
                        errors={errors}
                        control={control}
                        register={register}
                        rules={{
                          required: t("inputField.validation.required"),
                        }}
                        placeholder={t("inputField.placeholder.selectCountryISO2")}
                        options={countries}
                        optionLabel="iso2"
                        optionValue="id"
                      />
                      </div>
                    </div>
                    <div className="row">
                      <div className="input-blocks m-0">
                        <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                          <UnlimitToggle
                            isChecked={systemLanguage ? false : true}
                            label={t("tableColumnName.status")}
                            id="is_active"
                            register={register}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        {t("general.button.cancel")}
                      </button>
                      <UnlimitSubmitButton
                        label={
                          systemLanguage
                            ? t("general.button.update")
                            : t("general.button.submit")
                        }
                        isLoading={isLoading}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemLanguageDetail;
